export const WELCOME_PAGE_ID = 'welcomeScreen';
